
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/utenze-casa",
      function () {
        return require("private-next-pages/dashboard/utenze-casa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/utenze-casa"])
      });
    }
  